import React from 'react'
import { graphql } from 'gatsby'
import PDPHero from '../components/pdp-hero'
import FoldNav from '../components/fold-nav'
import LegacyContent from '../components/legacy-content'
import CriteoProduct from '../criteo/product'

export const query = graphql`
    query ProductPageQuery($id: String) {
        product(id: {eq: $id}){
            id
            productId
            product_name
            short_description
            description
            sku
            slug
            badge            
            cdnLinkMac
            cdnLinkWindows
            releasedDate
            rawHTMLContent
            shop_categories {
                name
                slug
            }
            childrenFile {
                childImageSharp {
                    gatsbyImageData
                }
            }
            thumbnails: childrenFile {
                childImageSharp {
                    gatsbyImageData(width: 96, height: 64)
                }
            }
            includes {
                slug
                shop_categories {
                    slug
                }
                product_name
            }
            requires {
                product_name
                shop_categories {
                    slug
                }
                slug
            }
            works_with {
                id
                image
                name
                path
            }
            appleSilicon
            macOS10
            macOS11
            macOS12
            macOS13
            macOS14
            win10
            win11
            AAX
            AU
            MPC
            MPCDesktop
            MPCKey61
            MPCLive
            MPCLive2
            MPCOne
            MPCOnePlus
            MPCX
            MPCXSE
            ProductCompaitbilityForce
            force
            standalone
            VST2
            VST3
        }
    }
`

export function Head(props) {
    const { data: { product } } = props
    const { product_name } = product
    return (
        <>
            <title>{product_name}</title>
            <CriteoProduct product={product} />
        </>
    )
}

export default function Product(props) {
    const { data } = props
    const { product } = data
    return (
        <>
            <PDPHero product={product} />
            <FoldNav product={product} />
            <LegacyContent product={product} />
        </>
    )
}
